import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-requisition-status-chip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './requisition-status-chip.component.html',
  styleUrls: ['./requisition-status-chip.component.scss']
})
export class RequisitionStatusChipComponent {

  @Input()
  status: string | null = '';

  get chipClass(): string {

    const status = (this.status ?? '').toLowerCase();

    switch (status) {

      case 'open':
        return 'open';

      case 'confirmed':
        return 'confirmed';

      case 'sample collected':
        return 'sample-collected';

      case 'done':
        return 'done';

      case 'rejected':
        return 'rejected';

      default:
        return 'default';
    }
  }
}